import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  VendorPaymentMethod,
  type VendorPaymentMethodConstructor,
} from './VendorPaymentMethod'

export const VendorPaymentMethodConstructorFactory =
  Factory.Sync.makeFactory<VendorPaymentMethodConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.finance.transactionType()),
    currencyId: Factory.each(() => faker.random.number()),
  })

export const VendorPaymentMethodFactory = EntityFactory(
  VendorPaymentMethod,
  VendorPaymentMethodConstructorFactory
)
